export default __webpack_public_path__ + "static/media/330_dummy2016-coach01-mobile-de.1a085e58.png";